import { mapGetters, mapActions } from 'vuex'
import { EXCLUDED_SHOWING_TOASTS_ROUTES } from '@/constant/routes'
import { isEmbedded } from '@/vuex/modules/embeddable/embeddable.utils'

export default {
  computed: {
    ...mapGetters('featureToggles', ['canUseBackgroundTaskProgress']),
    // Same surfaces the legacy export toasts skip: iframes/embeds and the share page.
    isBackgroundTaskCardAllowedHere() {
      const routeName = this.$route && this.$route.name
      return !isEmbedded() && !EXCLUDED_SHOWING_TOASTS_ROUTES.includes(routeName)
    },
  },
  methods: {
    ...mapActions('backgroundTasks', [
      'startBackgroundTaskAction',
      'updateBackgroundTaskProgressAction',
      'completeBackgroundTaskAction',
      'failBackgroundTaskAction',
    ]),
    findBackgroundTask(taskId) {
      return this.$store.getters['backgroundTasks/findTask'](taskId)
    },
  },
}
